import * as React from "react"

type LogoSvgProps = Omit<JSX.IntrinsicElements["svg"], "ref">

export type LogoSkeletonProps = LogoSvgProps & {
  logoName: string
}

export type LogoProps = Omit<LogoSkeletonProps, "logoName">

export function LogoSkeleton({ logoName, ...rest }: LogoSkeletonProps) {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      height="20"
      width="20"
      viewBox="0 0 20 20"
      data-testid={`logo-${logoName}`}
      aria-hidden
      {...rest}
    />
  )
}
